const TOGGLE_SIDE_MENU = 'TOGGLE_SIDE_MENU';
const REQUEST_PRODUCT_AUTOCOMPLETE = 'REQUEST_PRODUCT_AUTOCOMPLETE';
const RECEIVE_PRODUCT_AUTOCOMPLETE = 'RECEIVE_PRODUCT_AUTOCOMPLETE';

export default {
  TOGGLE_SIDE_MENU,
  REQUEST_PRODUCT_AUTOCOMPLETE,
  RECEIVE_PRODUCT_AUTOCOMPLETE
}
